import React, { Component } from 'react';
import { convertLocalDate } from './cleanDates';

export const DateFormatter = React.createClass({
  render() {
    return (this.props.value) ?
      <span>{convertLocalDate(this.props.value, 'MMM DD YYYY')}</span> :
      <span className="label label-danger">-</span>;
  },
});

export const DateFormatter2 = React.createClass({
  render() {
    if (this.props.value) {
      const date = moment(this.props.value).format("MM-DD-YY");
      return <span>{date}</span>;
    }
    return <span className="label label-danger">-</span>;
  },
});

export const TimeFormatter = React.createClass({
  render() {
    return (this.props.value) ?
      <span>{convertLocalDate(this.props.value, 'HH:mm')}</span> :
      <span className="label label-danger">-</span>;
  },
})

export const formatDate = (date) => {
  if (!date) { return; }
  let formattedDate = `${date.getFullYear()}-`;
  formattedDate += `${date.getMonth() + 1}-`;
  if (date.getDate() < 10) {
    formattedDate += `0${date.getDate()}`;
  } else {
    formattedDate += date.getDate();
  }
  return formattedDate;
};

export default DateFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/dateFormat.jsx